import { useMutation } from '@tanstack/react-query';
import API from '@/apiRequest';

export const useContracts = () => {
  const acceptContracts = useMutation({
    mutationFn: async ({ pendingContracts }) => {
      const { data } = await API.post('contracts/accept', {
        contracts: pendingContracts,
      });
      return data;
    },
  });

  return {
    acceptContracts,
  };
};
